<template>
  <el-dialog
    title="Defer Event"
    :visible.sync="isVisible"
    :close-on-click-modal="!isDeferringEvent"
    :close-on-press-escape="!isDeferringEvent"
    :show-close="!isDeferringEvent"
    @closed="$emit('destroy')"
  >
    <EventDeferForm
      :event="event"
      :note="note"
    />

    <template #footer>
      <el-button
        :disabled="isDeferringEvent"
        @click.native="isVisible = false"
      >
        Cancel
      </el-button>

      <el-button
        type="primary"
        :loading="isDeferringEvent"
        @click.native="deferEvent"
      >
        Defer Event
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import EventDeferForm from '@/components/Application/Sales/Events/Event/DeferForm'

export default {
  components: {
    EventDeferForm
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isVisible: true,
      isDeferringEvent: false,
      note: new this.$sdk.note()
    }
  },
  methods: {
    async deferEvent () {
      this.isDeferringEvent = true

      this.note.resource = this.event
      this.note.resource_uuid = this.event.id

      try {
        await this.note.create()
        await this.event.update(builder => { builder.include = [ 'account', 'type' ] })

        this.$message.success('Successfully updated Event')
        this.$emit('deferred-event', this.event)

        this.isVisible = false
      } catch {
        this.$message.error('Failed to update Event')
      }

      this.isDeferringEvent = false
    }
  }
}
</script>
